import { ShopListItem } from 'components/Types/Tenant/shop.type';
import React, { createContext, useContext } from 'react';

interface ShopContextType {
  shop: ShopListItem;
}

const ShopContext = createContext<ShopContextType | undefined>(undefined);

export const ShopProvider: React.FC<{ shop: ShopListItem; children: React.ReactNode }> = ({
  shop,
  children,
}) => {
  return <ShopContext.Provider value={{ shop }}>{children}</ShopContext.Provider>;
};

export const useShop = (): ShopContextType => {
  const context = useContext(ShopContext);
  if (!context) {
    throw new Error('useShop must be used within a ShopProvider');
  }
  return context;
};
